/**
 * Links aus Benachrichtigungen (F-30, auch aus Push F-31) fuehren direkt zum
 * Eintrag: `?aufgabe=<id>` oeffnet die Aufgabe, `/kalender?termin=<Vorkommen>
 * &datum=<Tag>` den Termin am Tag, `?meldungen=1` die Glocke. Danach
 * verschwindet der Parameter wieder aus der Adresse.
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getOccurrences } from '@/db/repositories/events';
import { useTaskDialog } from '@/modules/tasks/taskDialogStore';
import { useGlocke } from '@/modules/benachrichtigungen/glockeStore';
import { useCalendarStore } from '@/store/calendar';
import { useUiStore } from '@/store/ui';
import { addDays, isLocalDate } from '@/lib/datetime';
import type { LocalDateTime } from '@/domain/types';

export function DeepLinks() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const aufgabeOeffnen = useTaskDialog((s) => s.open);
  const glocke = useGlocke((s) => s.setOffen);
  const setView = useUiStore((s) => s.setCalendarView);
  const setAnchor = useCalendarStore((s) => s.setAnchor);
  const select = useCalendarStore((s) => s.select);

  useEffect(() => {
    const p = new URLSearchParams(search);
    const aufgabe = p.get('aufgabe');
    const termin = p.get('termin');
    const datum = p.get('datum') ?? '';
    const meldungen = p.get('meldungen');
    if (!aufgabe && !termin && !meldungen) return;
    const rest = new URLSearchParams(search);
    for (const k of ['aufgabe', 'meldungen', ...(termin ? ['termin', 'datum'] : [])]) rest.delete(k);
    const neu = `${pathname}${rest.size > 0 ? `?${rest}` : ''}`;

    if (aufgabe) aufgabeOeffnen(aufgabe);
    if (meldungen) glocke(true);
    if (termin && isLocalDate(datum)) {
      setView('tag');
      setAnchor(datum);
      void getOccurrences({ from: `${datum}T00:00` as LocalDateTime, to: `${addDays(datum, 1)}T00:00` as LocalDateTime })
        .then((liste) => { const o = liste.find((x) => x.occurrenceId === termin); if (o) select(o); });
    }
    navigate(neu, { replace: true });
  }, [pathname, search, navigate, aufgabeOeffnen, glocke, setView, setAnchor, select]);

  return null;
}
